/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type MigrateRemoteSessionIssuerRequestBody = {
  /**
   * The organization- or project-level remote_session_issuer to migrate away from; soft-deleted on success.
   */
  sourceId: string;
  /**
   * The global remote_session_issuer to migrate onto; survives and adopts the source's clients.
   */
  targetId: string;
};

/** @internal */
export type MigrateRemoteSessionIssuerRequestBody$Outbound = {
  source_id: string;
  target_id: string;
};

/** @internal */
export const MigrateRemoteSessionIssuerRequestBody$outboundSchema:
  z.ZodMiniType<
    MigrateRemoteSessionIssuerRequestBody$Outbound,
    MigrateRemoteSessionIssuerRequestBody
  > = z.pipe(
    z.object({
      sourceId: z.string(),
      targetId: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        sourceId: "source_id",
        targetId: "target_id",
      });
    }),
  );

export function migrateRemoteSessionIssuerRequestBodyToJSON(
  migrateRemoteSessionIssuerRequestBody: MigrateRemoteSessionIssuerRequestBody,
): string {
  return JSON.stringify(
    MigrateRemoteSessionIssuerRequestBody$outboundSchema.parse(
      migrateRemoteSessionIssuerRequestBody,
    ),
  );
}
